<template>
  <div class="alipay_promote_param_manage">
    <el-divider content-position="left">支付宝推广订单参数管理</el-divider>
    <el-row style="margin-bottom: 0.4rem">
      <el-col>
        <el-button type="primary" size="small" @click="handleAddOpen">新增</el-button>
        <el-button
          type="primary"
          size="small"
          @click.native="$router.push('setting_panel')"
          >返回上一级</el-button
        >
      </el-col>
    </el-row>

    <el-table
      height="calc(100vh - 276px)"
      :data="paramList"
      size="medium"
      style="width: 100%"
      border
    >
      <el-table-column label="pageId" width="150">
        <template slot-scope="scope">
          {{ scope.row.page_id }}
        </template>
      </el-table-column>
      <el-table-column label="推广页名称" width="200">
        <template slot-scope="scope">
          {{ scope.row.page_name }}
        </template>
      </el-table-column>
      <el-table-column label="所属账户" width="200">
        <template slot-scope="scope">
          {{ scope.row.account_type }}
        </template>
      </el-table-column>
      <el-table-column label="订单类型" width="auto">
        <template slot-scope="scope">
          {{ scope.row.order_type.order_reg_name }}
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="120">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            icon="el-icon-edit"
            circle
            @click="handleEditOpen(scope.$index, scope.row)"
            style="margin-right: 0.4rem"
          >
          </el-button>
          <el-popconfirm
            @onConfirm="handleDelete(scope.$index, scope.row)"
            confirmButtonText="确定"
            cancelButtonText="取消"
            icon="el-icon-info"
            iconColor="red"
            title="确定删除吗？"
          >
            <el-button
              size="mini"
              type="danger"
              slot="reference"
              icon="el-icon-delete"
              circle
            >
            </el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <!--页码-->
    <el-footer class="page-footer">
      <el-pagination
        background
        class="pagination-style"
        layout="sizes, total, prev, pager, next, jumper"
        :hide-on-single-page="false"
        :current-page="pageOption.currentPage"
        :page-sizes="[10, 20, 30, 50, 100, 500]"
        :page-size="pageOption.pageSize"
        :total="pageOption.total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </el-footer>

    <!-- 添加-->
    <el-drawer
      title="添加/修改"
      :visible.sync="windowDrawer"
      :direction="direction"
      :before-close="handleClose"
      size="40%"
    >
      <div class="m-tabs-content">
        <el-form :model="formData" label-width="120px" :rules="rules" ref="formData">
          <el-form-item label="Page Id" prop="pageId">
            <el-input
              type="text"
              size="mini"
              placeholder="请输入推广页pageId"
              v-model="formData.pageId"
            ></el-input>
          </el-form-item>
          <el-form-item label="Page Name" prop="pageName">
            <el-input
              type="text"
              size="mini"
              placeholder="请输入推广页名称"
              v-model="formData.pageName"
            ></el-input>
          </el-form-item>
          <el-form-item label="订单类型" prop="order_reg_type">
            <el-select
              v-model="formData.order_reg_type"
              placeholder="请选择订单类型"
              size="mini"
              clearable
            >
              <el-option
                v-for="reg in orderRegTypes"
                :key="reg.order_reg_id"
                :label="reg.order_reg_name"
                :value="reg.order_reg_id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属账号" prop="account_type">
            <el-select
              v-model="formData.account_type"
              placeholder="请选择所属账号"
              size="mini"
              clearable
            >
              <el-option label="优开信息科技" value="优开信息科技"></el-option>
              <el-option label="账六六信息科技" value="账六六信息科技"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              style="float: right; margin-top: 0.4rem"
              size="mini"
              @click="submitCheckForm('formData')"
              >保存</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-drawer>
  </div>
</template>
<script>
export default {
  name: "AlipayPromoteParamManage",
  data() {
    return {
      inputSize: "small",
      direction: "rtl",
      pageOption: {
        total: 0,
        currentPage: 1,
        pageSize: 30,
      },
      windowDrawer: false,
      paramList: [],
      orderRegTypes: [],
      formData: {
        id: '',
        pageId: '',
        pageName: '',
        account_type: null,
        order_reg_type: ''
      },
      rules: {
        pageId: [{ required: true, message: "请填写推广页pageId", trigger: "blur" }],
        order_reg_type: [{ required: true, message: "请选择订单类型", trigger: "blur" }],
        account_type: [{ required: true, message: "请选择所属账户", trigger: "blur" }],
      },
    };
  },
  computed: {
    searchStr: function () {
      let str = "";
      for (let key in this.searchArr) {
        str += "&" + key + "=" + this.searchArr[key];
      }
      return str;
    },
    collapse() {
      return this.$store.state.collapse;
    },
  },
  methods: {
    getPromoteParamList() {
      this.$axios
        .get(
          "/api/admin/alipay/promote/param/list?page=" +
            this.pageOption.currentPage +
            "&pageSize=" +
            this.pageOption.pageSize
        )
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.paramList = data.data.list.data;
            this.orderRegTypes = data.data.orderRegTypes;
            this.pageOption.total = data.data.list.total;
            this.pageOption.currentPage = data.data.list.current_page;
          }
        });
    },
    handleAddOpen() {
      this.windowDrawer = true;
    },
    submitCheckForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios
            .post("/api/admin/alipay/promote/param/add", { formData: this.formData })
            .then((res) => {
              let { data } = res;
              if (data.code === 0) {
                this.windowDrawer = false;
                this.getPromoteParamList();
                this.clearSaveData();
                this.$message.success(data.msg);
              } else {
                this.$message.error(data.msg);
              }
            });
        } else {
          return false;
        }
      });
    },
    handleEditOpen(index, row) {
      this.formData.id = row.id;
      this.formData.pageId = row.page_id;
      this.formData.pageName = row.page_name;
      this.formData.account_type = row.account_type;
      this.formData.order_reg_type = row.order_reg_type;
      this.windowDrawer = true;
    },
    handleDelete(index, row) {
      this.$axios
        .get("/api/admin/alipay/promote/param/delete?id=" + row.id)
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.$message.error(data.msg);
            this.getPromoteParamList();
          }
        })
        .catch((_) => {});
    },
    handleSizeChange(val) {
      this.pageOption.pageSize = val;
      this.getPromoteParamList();
    },
    handleCurrentChange(val) {
      this.pageOption.currentPage = val;
      this.getPromoteParamList();
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          this.clearSaveData();
          done();
        })
        .catch((_) => {});
    },
    clearSaveData() {
      this.formData.id = "";
      this.formData.pageId = "";
      this.formData.pageName = "";
      this.formData.order_reg_type = "";
      this.formData.account_type = null;
    },
  },
  mounted() {
    this.getPromoteParamList();
  },
};
</script>

<style scoped lang="stylus">
@import '~styles/varibles.styl'
@import '~styles/vertical.styl'
@import '~styles/icon.styl'
.el-drawer__wrapper >>> .el-drawer
  overflow-y: auto
.el-drawer__wrapper >>> .el-drawer__header span
  color: #4c87fc
  font-size 0.36rem
  font-weight 400
.alipay_promote_param_manage
  marginLeft()
.mt-10
  margin-top: .2rem
.tr
  text-align: right
.m-tabs-content
  padding: 0 .2rem 0 .4rem
  overflow-y auto
  .m-label
    line-height: .64rem
  .el-row
    margin-bottom: .4rem
  .el-date-editor.el-input, .el-date-editor.el-input__inner
    width: 100%
  .el-select
    width: 100%
.alipay_promote_param_manage >>> .el-table__header th
  color: #333333
  background-color: #ECF4FF
.addCon
  padding: .2rem
  text-align: right
.count_style
  display: inline-block
  overflow: hidden
  text-overflow: ellipsis
  white-space: nowrap
.page-footer
  position: fixed;
  bottom: 0;
  left: 0;
  height: 80px !important;
  background: #fff;
  width: 100%;
  z-index: 2;
.pagination-style
  padding-top: 25px;
  text-align: right;
</style>



// WEBPACK FOOTER //
// src/pages/setting_panel/AlipayPromoteParamManage.vue